import React from 'react';
import { useSelector, useDispatch } from '../common/react-redux-hooks';
import { setFileStructureFormat } from '../../actions/rldToolActions';
import CommonDropdown from '../common/CommonDropdown';
import { RLD_FILE_STRUCTURE_FORMATS } from './RldConstant';

const RldFileStructureFormat = () => {
  const { fileStructureFormat } = useSelector(state => state.rldTool);

  // The CommonDropdown uses the property 'value' to handle list item, and it does not accept Zero,
  // Whereas the array starts the indces from Zero, to match it below change required
  const fileStructureFormatIndex = fileStructureFormat - 1;
  const selectedItem = RLD_FILE_STRUCTURE_FORMATS[fileStructureFormatIndex];
  const { label: selectedItemLabel } = selectedItem;

  const dispatch = useDispatch();

  const changeFileStructureFormat = e => {
    dispatch(setFileStructureFormat(e.value));
  };

  return (
    <div className="account_component">
      <div className="account_selector">
        <div className="account_item export_format">
          <CommonDropdown
            listData={RLD_FILE_STRUCTURE_FORMATS}
            defaultSelected={selectedItem}
            itemClickFn={changeFileStructureFormat}
            filterSearch={false}
            placeHolder={selectedItemLabel}
          />
        </div>
      </div>
    </div>
  );
};

export default RldFileStructureFormat;
